/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    export class AccountDialog extends NoboxEntityDialog<AccountRow, any> {
        protected getFormKey() { return AccountForm.formKey; }
        protected getIdProperty() { return AccountRow.idProperty; }
        protected getLocalTextPrefix() { return AccountRow.localTextPrefix; }
        protected getNameProperty() { return AccountRow.nameProperty; }
        protected getService() { return AccountService.baseUrl; }
        protected getDeletePermission() { return AccountRow.deletePermission; }
        protected getInsertPermission() { return AccountRow.insertPermission; }
        protected getUpdatePermission() { return AccountRow.updatePermission; }

        protected form = new AccountForm(this.idPrefix);
        public isReadonly: boolean;

        constructor(container?: JQuery) {
            super(container);
            this.form.Channel.change(() => {
                if (this.form.Channel.get_value() == "2") {
                    Serenity.EditorUtils.setRequired(this.form.ApiClient, true);
                } else {
                    Serenity.EditorUtils.setRequired(this.form.ApiClient, false);
                    //Q.addValidationRule(this.form.ApiClient.getGridField(), "Halo", () => {

                    //});
                }
                this.showSMTP(this.form.IsSMTP.get_value(), this.form.Channel.get_value());
            })
            this.form.IsSMTP.change(() => {
                this.showSMTP(this.form.IsSMTP.get_value(), this.form.Channel.get_value());
            })
            this.form.Provider.change(() => {
                if (this.form.IsSMTP.value == "API") {
                    var value = this.form.Provider.selectedItem;
                    Serenity.EditorUtils.setValue(this.form.BaseUrlApi, value["Url"])
                }
            })
        }
        protected updateInterface() {
            super.updateInterface();
            if (this.isEditMode()) {
                this.element.find(".set-api-btn").toggle(true)
                this.element.find(".set-chatbot-btn").toggle(true)
            } else if (this.isNewOrDeleted()) {
                this.element.find(".set-api-btn").toggle(false)
                this.element.find(".set-chatbot-btn").toggle(false)
            }
        }
        loadEntity(entity: AccountRow) {
            super.loadEntity(entity);
        }
        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.isReadonly == true) {
                Serenity.EditorUtils.setReadonly(this.element.find('.editor'), true);
                this.element.find('sup').hide();
                this.saveAndCloseButton.remove();
                this.applyChangesButton.remove();
                this.deleteButton.remove();
                if (this.isEditMode()) {
                    var entityType = super.getEntitySingular();

                    // get name field value of record this dialog edits
                    let name = this.getEntityNameFieldValue() || "";

                    // you could use format with a local text, but again demo...
                    this.dialogTitle = 'View ' + entityType + " (" + name + ")";
                }
            }
        }
        protected showSMTP(issmtp, chid) {
            $(".email-btn .button-outer .button-inner").text('Test ' + issmtp)
            this.element.find(".email-btn").attr("title", "Test " + issmtp);
            if (chid == "19") {
                this.element.find(".email-btn").show();
            } else {
                this.element.find(".email-btn").hide();
            }
            var $form = this.form;
            //SMTP
            var value = issmtp == "SMTP" && chid == "19" ? true : false;
            $form.Host.getGridField().toggle(value);
            $form.Port.getGridField().toggle(value);
            $form.UseSSL.getGridField().toggle(value);
            $form.From.getGridField().toggle(value);
            $form.Username.getGridField().toggle(value);
            $form.Password.getGridField().toggle(value);

            //API
            value = issmtp == "API" && chid == "19" ? true : false;
            $form.EndpointApi.getGridField().toggle(value);
            $form.Provider.getGridField().toggle(value);
            $form.BaseUrlApi.getGridField().toggle(value);
            $form.KeyApi.getGridField().toggle(value);
            $form.FromApi.getGridField().toggle(value);
            if (chid == "19") {
                $form.ApiId.getGridField().toggle(false);
                $form.ApiClient.getGridField().toggle(false);
                $form.ApiSecret.getGridField().toggle(false);
                $form.ApiExtra.getGridField().toggle(false);
                $form.IsSMTP.getGridField().toggle(true);
            } else {
                $form.ApiId.getGridField().toggle(true);
                $form.ApiClient.getGridField().toggle(true);
                $form.ApiSecret.getGridField().toggle(true);
                $form.ApiExtra.getGridField().toggle(true);
                $form.IsSMTP.getGridField().toggle(false);
            }
        }
        protected getToolbarButtons() {
            var btn = super.getToolbarButtons();
            var $this = this;
            btn.push({
                cssClass: "email-btn",
                hint: "Test",
                title: "Test",
                separator: true,
                icon: "fa-check-square text-green",
                visible: false,
                onClick: function () {
                    if ($this.validateForm()) {
                        var value = prompt("Enter your Email");
                        if (!Q.isEmptyOrNull(value)) {
                            $this.TestMail(value);
                        }
                    }
                }
            });

            btn.push({
                cssClass: "set-api-btn",
                hint: "Import setting API from another account",
                title: "API",
                separator: true,
                icon:"fa-download text-blue",
                visible: false,
                onClick: () => {
                    var dlg = new AccountAPIFormDialog();
                    dlg.setTemplate = (item) => {
                        Serenity.EditorUtils.setValue(this.form.KeyApi, item.KeyApi);
                        Serenity.EditorUtils.setValue(this.form.FromApi, item.FromApi);
                        Serenity.EditorUtils.setValue(this.form.EndpointApi, item.EndpointApi);
                        Serenity.EditorUtils.setValue(this.form.BaseUrlApi, item.BaseUrlApi);
                        Serenity.EditorUtils.setValue(this.form.Provider, item.Provider);
                        Serenity.EditorUtils.setValue(this.form.Password, item.Password);
                        Serenity.EditorUtils.setValue(this.form.Username, item.Username);
                        Serenity.EditorUtils.setValue(this.form.From, item.From);
                        Serenity.EditorUtils.setValue(this.form.UseSSL, item.UseSSL);
                        Serenity.EditorUtils.setValue(this.form.Port, item.Port);
                        Serenity.EditorUtils.setValue(this.form.Host, item.Host);
                        Serenity.EditorUtils.setValue(this.form.IsSMTP, item.IsSMTP);
                        Serenity.EditorUtils.setValue(this.form.ApiExtra, item.ApiExtra);
                        Serenity.EditorUtils.setValue(this.form.ApiSecret, item.ApiSecret);
                        Serenity.EditorUtils.setValue(this.form.ApiClient, item.ApiClient);
                        Serenity.EditorUtils.setValue(this.form.ApiId, item.ApiId);
                    }
                    dlg.loadNewAndOpenDialog();
                }
            })

            btn.push({
                cssClass: "set-chatbot-btn",
                hint: "Import setting AI Chatbot from another account",
                title: "AI Chatbot",
                separator: true,
                icon:"fa-download text-blue",
                visible: false,
                onClick: () => {
                    var dlg = new AccountChatbotFormDialog();
                    dlg.setTemplate = (item) => {
                        Serenity.EditorUtils.setValue(this.form.BotActive, item.BotActive);
                        Serenity.EditorUtils.setValue(this.form.BotChannel, item.BotChannel);
                        Serenity.EditorUtils.setValue(this.form.BotEndpoint, item.BotEndpoint);
                        Serenity.EditorUtils.setValue(this.form.BotEngine, item.BotEngine);
                        Serenity.EditorUtils.setValue(this.form.BotName, item.BotName);
                        Serenity.EditorUtils.setValue(this.form.BotOptions, item.BotOptions);
                        Serenity.EditorUtils.setValue(this.form.BotPassword, item.BotPassword);
                        Serenity.EditorUtils.setValue(this.form.BotUsername, item.BotUsername);
                    }
                    dlg.loadNewAndOpenDialog();
                }
            })
            return btn;
        }
        protected TestMail(mailto) {
            var $form = this.form;
            Q.serviceCall({
                blockUI: true,
                request: {
                    IsSMTP: $form.IsSMTP.value == "API" ? 0 : 1,
                    Host: $form.Host.value,
                    Port: $form.Port.value,
                    UseSSL: $form.UseSSL.value == true ? 1 : 0,
                    Username: $form.Username.value,
                    Password: $form.Password.value,
                    MailTo: mailto,
                    MailFrom: $form.IsSMTP.value == "API" ? $form.FromApi.value : $form.From.value,
                    Provider: $form.Provider.value,
                    ApiKey: $form.KeyApi.value,
                    Url: $form.BaseUrlApi.value,
                    Endpoint: $form.EndpointApi.value,
                },
                url: "/Services/Nobox/Account/TestMail",
                onSuccess: (res) => {
                    if (!res.IsError) {
                        Q.notifySuccess("Please check your inbox " + mailto + ", if you don't get an email, your setting SMTP or API is invalid");
                    } else {
                        Q.notifyError(res.ErrMsg);
                    }
                }
            });
        }
        protected save(callback) {
            var $this = this;
            var valChannel = $this.form.Channel.value;
            var valApiId = $this.form.ApiId.value;
            var valApiSecret = $this.form.ApiSecret.value;
            if (this.validateForm()) {
                if (valChannel == '2') {
                    if (valApiId == null || valApiId == "") {
                        Serenity.EditorUtils.setValue(this.form.ApiId, "17349");
                    }
                    if (valApiSecret == null || valApiSecret == "") {
                        Serenity.EditorUtils.setValue(this.form.ApiSecret, "344583e45741c457fe1862106095a5eb");
                    }
                }
                //var arrUsers = $this.form.Users.value.split(",");
                //arrUsers.indexOf("0") != - 1 ? $this.form.Users.value = "0" : $this.form.Users.value = $this.form.Users.value;
                super.save(callback);
            }
        }
    }
}